import { getUrl } from './url';

const backendFetch = async (input, init, idToken, isFormData, isDirectApi) => {
  const request = {
    ...{
      ...init,
      headers: {
        ...(init?.headers || {}),
        ...(init?.body ? { 'Content-Type': 'application/json' } : {}),
        ...(process.env.NEXT_PUBLIC_SECURITY_HEADER
          ? {
              [process.env.NEXT_PUBLIC_SECURITY_HEADER]:
                process.env.NEXT_PUBLIC_SECURITY_HEADER_VALUE
            }
          : {}),
        ...(idToken ? { 'x-ath-auth': idToken } : {})
      },
      ...(init?.body
        ? { body: isFormData ? init.body : JSON.stringify(init.body) }
        : {})
    }
  };
  if (isFormData) {
    delete request.headers['Content-Type'];
  }

  // proxy設定されている時はproxyを使う、ただしurlがlocalhostの時は使わない
  if (
    process.env.PROXY &&
    typeof window === 'undefined' &&
    !process.env.NEXT_PUBLIC_BACKEND_URL.startsWith('http://localhost')
  ) {
    const { ProxyAgent } = await import('proxy-agent');
    request.agent = new ProxyAgent();
    console.log('proxy');
    fetch = (await import('node-fetch')).default;
  }

  return fetch(
    `${
      isDirectApi ? getUrl('/api/') : process.env.NEXT_PUBLIC_BACKEND_URL
    }${input}`,
    request
  ).then(async (response) => {
    const data = await response.json();
    if (data?.message === 'The incoming token has expired') {
      throw new TokenExpiredError(data.message);
    }
    if (data.error) {
      throw new Error(`Server error: ${data.error}`);
    }

    return {
      data,
      result: data.result,
      status: data.status,
      errorCode: data.errorCode
    };
  });
};

export class TokenExpiredError extends Error {}

export default backendFetch;
